import { TFunction } from '@lyearn/i18n';

import { AgendaTemplateFragment } from './graphql/fragments/generated/AgendaTemplate';

export const getTemplate = (t: TFunction, template?: AgendaTemplateFragment) => {
  return template?.name ? template?.name : t('1on1s:Templates.UntitledTemplate');
};
